export const DEAL_SCREEN_EXPERIENCE = {
    BASE: 'base',
    DEAL_CENTRAL: 'DealCentral'
};
